import GameService from '~/services/game.service';
import { formatDateForLogbook } from '~/lib/helpers';
import { gameSelectors, logbookSelectors } from '~/store/selectors';
import { financialStatementsActions } from '~/store/actions';
// ---- internal imports ----

import * as types from './actionTypes';
// ---- local imports ----

export function logbookLoaded(logbook = {}, systemLogbook = {}, isLogbookAutomatedByDate = {}) {
	if (logbook === undefined || logbook === null) {
		logbook = {};
	}

	if (systemLogbook === undefined || systemLogbook === null) {
		systemLogbook = {};
	}

	if (isLogbookAutomatedByDate.length === 0) {
		isLogbookAutomatedByDate = {};
	}

	return {
		type: types.LOGBOOK_LOADED,
		logbook,
		systemLogbook,
		isLogbookAutomatedByDate
	};
}

export function fetchUpdatedLogbook(logbookData = null) {
	return async (dispatch, getState) => {
		try {
			if (!logbookData) {
				const gameUserId = gameSelectors.getGameId(getState());
				const result = await GameService.getLogbook(gameUserId);
				if (!result.isSuccess) {
					return;
				}
				logbookData = result.data;
			}

			const { 
				system_log: systemLog,
				logbook,
				is_logbook_automated_by_date: isLogbookAutomatedByDate,
			}  = logbookData;

			dispatch({ 
				type: types.LOGBOOK_FETCH_UPDATED_BY_SYSTEM,
				systemLogbook: systemLog,
				isLogbookAutomatedByDate
			});

			if (logbookSelectors.shouldAutomaticallyFillLogbook(getState())) {
				dispatch({ 
					type: types.LOGBOOK_FETCH_UPDATED_BY_BOOKKEEPER,
					logbook,
				});
			}
		} catch (error) {
			console.error(error);
		}
	};
}

export function updateSalesLogFor(date, newSalesLog) {
	return async (dispatch, getState) => {
		try {
			const gameUserId = gameSelectors.getGameId(getState());

			dispatch({
				type: types.LOGBOOK_UPDATE_SALESLOG_FOR_DATE,
				date: formatDateForLogbook(date),
				newSalesLog,
				gameUserId
			});
		} catch (error) {
			console.error(error);
		}
	};
}

export function updatePurchasesLogFor(date, newPurchasesLog) {
	return async (dispatch, getState) => {
		try {
			const gameUserId = gameSelectors.getGameId(getState());

			dispatch({
				type: types.LOGBOOK_UPDATE_PURCHASES_LOG_FOR_DATE,
				date: formatDateForLogbook(date),
				newPurchasesLog,
				gameUserId
			});
		} catch (error) {
			console.error(error);
		}
	};
}

export function updateGeneralLogFor(date, newGeneralLog) {
	return async (dispatch, getState) => {
		try {
			const gameUserId = gameSelectors.getGameId(getState());
			dispatch({
				type: types.LOGBOOK_UPDATE_GENERAL_LOG_FOR_DATE,
				date: formatDateForLogbook(date),
				newGeneralLog,
				gameUserId
			});
		} catch (error) {
			console.error(error);
		}
	};
}

export function updateGeneralLogAfterProfitDistribution(date, amount) {
	//	This function will be removed after logbook
	//	 logic is moved from frontend to backend
	return async (dispatch, getState) => {
		const shouldAutomaticallyFillLogbook = logbookSelectors.
			shouldAutomaticallyFillLogbook(getState());

		if (!shouldAutomaticallyFillLogbook) {
			return;
		}

		const gameUserId = gameSelectors.getGameId(getState());
		const generalLog = logbookSelectors.getGeneralLogFor(getState(), date);

		const newGeneralLog = {
			...generalLog,
			[Object.values(generalLog).length + 1]: {
				description: 'Profit Distribution',
				amount
			}
		};

		dispatch({
			type: types.LOGBOOK_UPDATE_GENERAL_LOG_FOR_DATE,
			date: formatDateForLogbook(date),
			newGeneralLog,
			gameUserId
		});
	};
}

export function saveTradeshowSalesLog(tradeshowSalesSummary) {
	return async (dispatch, getState) => {
		const gameUserId = gameSelectors.getGameId(getState());
		const result = await GameService.saveTradeshowSalesLog(gameUserId, tradeshowSalesSummary);

		if (!result.isSuccess) {
			return;
		}

		dispatch(fetchUpdatedLogbook());
	};
}
